module.exports = __webpack_public_path__ + "static/media/SMUD_Logo.014bd3bc.svg";